import { mapActions } from "vuex";

export const listsMixin = {
  methods: {
    ...mapActions(["GET_LIST"]),

    lossValueError(val) {
      return !(
        (val && val >= 0 && !val.split(".")[1]) ||
        (val &&
          val.split(".")[1] &&
          ((val && val.split(".")[1].length <= 5) ||
            (val && val.split(".")[1].length === 0)))
      );
    },

    getListElementLabel(listElement) {
      if (listElement) {
        if (
          listElement.hasOwnProperty("client_label") &&
          listElement.client_label &&
          listElement.client_label !== ""
        ) {
          return listElement.client_label;
        } else if (
          listElement.hasOwnProperty("libelle") &&
          listElement.libelle &&
          listElement.libelle !== ""
        ) {
          return listElement.libelle;
        } else {
          return listElement.code;
        }
      }
    },

    listElementNormalizer(node) {
      return {
        id: node.code,
        label: this.getListElementLabel(node),
        isDisabled: node.deleted
      };
    },

    getList(listName, code = [], includeDeleted = false) {
      return new Promise(resolve => {
        if (listName.startsWith("l_")) {
          listName.replace("l_", "list_");
        }
        let storedList = this.$store.getters.getListOfOptionsByListName(
          listName,
          code,
          includeDeleted
        );
        if (storedList) resolve(storedList);
        else
          this.GET_LIST({
            listName: listName,
            code: code,
            includeDeleted: includeDeleted
          }).then(list => {
            resolve(list);
          });
      });
    },
    checkFloat(e) {
      const regex = /^[\.,0-9]*$/;
      //if input is not a number a comma or a dot, validates to true
      if (!regex.test(e.key)) {
        e.preventDefault();
      }
    },
  }
};



// WEBPACK FOOTER //
// ./src/mixins/listsMixin.js